import { Typography, Divider, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import '../../styles/mobidawg-style.scss'
import { projectList } from '../../datamodels/Projects';
import HomeBanner from './HomeBanner';
import HomeServicesSolutions from './HomeServicesSolutions';
import { logEvent } from '../../services/firebase.tsx'; // Import the initialized app
// In your components (e.g., Header.js, Home.js, etc.)
import { analytics } from '../../services/firebase'; // Import the analytics instance
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomeIndustries from './HomeIndustries';


function Home() {
    const location = useLocation();

    useEffect(() => {
        logEvent(analytics, 'page_view', {
            page_location: window.location.href,
            page_path: location.pathname,
            page_title: document.title,
        })

        if ((location.pathname === '/') || (location.pathname === '/home')) {
            logEvent(analytics, 'home_page_loaded')
        }

    }, [location])

    return (
        <Box sx={{ width: '100%' }}>
            <HomeBanner />
            <HomeServicesSolutions />
            <Typography sx={{ 
                            height: '3rem', 
                            fontSize: '1.2rem', fontWeight: 'bold', 
                            m: '0rem', mt:4, p: '0rem',
                            boxSizing: 'border-box',
                            display: 'flex',                // Enable flexbox layout
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundImage: 'conic-gradient(from 90deg,rgb(205, 236, 200) 10%,rgb(177, 205, 172) 80%,rgb(205, 236, 200) 29% )'}}>
            Projects
            </Typography>
            <Grid container spacing={2} sx={{ mt: 0 }}> {/* Use Grid for layout */}
                    {projectList.filter(project => project.isVisible ?? true).sort((a, b) => a.industry.localeCompare(b.industry)).map((project) => (
                        <Grid item xs={12} sm={12} md={6} lg={4} key={project.id}>
                                <Card sx={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
                                    <CardActionArea sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}> {/* Make the whole card clickable */}
                                        <CardContent sx={{ padding: 0, flex: 1, width: '100%' }}> {/* Content of the card */}
                                            <Typography
                                                variant="h6"
                                                component="div"
                                                sx={{  // Use sx prop for styling
                                                    backgroundColor: '#013220',      // Set background color
                                                    color: 'white',                 // Set text color
                                                    padding: '2px 4px 8px 4px',     // TOP RIGHT BOTTOM LEFT
                                                    borderRadius: '4px',            // Add rounded corners (optional)
                                                    marginBottom: '0.5rem',
                                                    width: '100%',
                                                    fontSize: '1.2rem',
                                                    boxSizing: 'border-box',
                                                    textAlign: 'center',
                                                    wordWrap: 'break-word',
                                                    overflowWrap: 'break-word'
                                                }}>
                                                {project.title}
                                            </Typography>                                        
                                            <Divider/ >
                                            <Typography gutterBottom variant="body2" color="text.primary" sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                <b>Industry:</b> {project.industry}
                                            </Typography>
                                            <Typography gutterBottom variant="h5" color="text.secondary" fontSize={'0.8rem'} sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                {project.subtitle}
                                            </Typography>
                                            <Typography gutterBottom variant="h5" color="text.secondary" fontSize={'0.8rem'} sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                {project.brief}
                                            </Typography>
                                            <Typography gutterBottom variant="body2" color="text.primary" sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                <b>Skills:</b> {project.description}
                                            </Typography>
                                            <Typography  gutterBottom variant="body2" color="text.secondary" sx={{ m:'1rem', wordWrap: 'break-word', overflowWrap: 'break-word' }}>
                                                <b>Platform:</b> {project.technologies}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                        </Grid>
                    ))}
            </Grid>
            <HomeIndustries />
        </Box>
    );
}

export default Home;
